import { Link } from "react-scroll";
import styled from "styled-components";
import parse from "html-react-parser";
import { IDescription } from "@interfaces";
import { StyledDescription, StyledNavBar } from "@components";
import { theme } from "@utilities";

interface IProps {
    data: IDescription[];
    currentTagIndex: number;
    _onEnter: (index: number) => void;
}

interface INavItemProps {
    active: number;
}

export const InfoBoxComponent = (props: IProps) => {
    const { data, currentTagIndex, _onEnter } = props;

    const activeItem = data[currentTagIndex];
    return (
        <div>
            <StyledNavBar>
                {data.map((item, index) => {
                    const titleMapping: Record<string, string> = {
                        Description: "Description",
                        Itinerary: "Itinerary",
                        "Departures/Pickups": "Departure",
                        "Cancellation Policy": "Policy",
                    };

                    const normalizedTitle = titleMapping[item.title] || item.title;

                    return (
                        <div key={index}>
                            <StyledNavItem
                                to={item.title}
                                smooth={true}
                                duration={500}
                                offset={-120}
                                active={currentTagIndex === index ? 1 : 0}
                                onClick={() => _onEnter(index)}
                            >
                                <div className="title">
                                    {normalizedTitle}
                                    <div className="line"></div>
                                </div>
                            </StyledNavItem>
                        </div>
                    );
                })}
            </StyledNavBar>

            {activeItem && (
                <StyledDescription name={activeItem.title}>
                    <div className="content">{parse(activeItem.content!)}</div>
                </StyledDescription>
            )}
        </div>
    );
};

const StyledNavItem = styled(Link)<INavItemProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    background-color: #eff4fb;
    cursor: pointer;
    transition:
        background-color 0.3s ease-in-out,
        color 0.3s ease-in-out;
    padding: 0 16px;

    .title {
        font-size: 14px;
        color: #898d8f;
        font-weight: 500;
        line-height: 26px;
        position: relative;
    }

    /*
     * Hover only applies to the inactive tabs: :hover outranks the flat
     * declarations the active branch injects below, so an unguarded rule would
     * strip the highlight off the current tab as the cursor crossed it. Gated on a
     * real pointer so touch devices don't retain the hover state after a tap.
     */
    ${({ active }) =>
        !active &&
        `
        @media (hover: hover) {
            &:hover {
                background-color: #e3ebf6;

                .title {
                    color: #6b7073;
                }
            }
        }
    `}

    ${({ active }) =>
        active &&
        `
        background-color: ${theme.colors.main};
        .title {
            color: ${theme.colors.button_text};
        }
    `}
`;
